import './Header.css';
import { AppBar, Badge, IconButton, Menu, MenuItem, Toolbar, Typography } from '@material-ui/core';
import { CategoryDetails, StoreData } from '../../data/store-data';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Menu as MenuIcon, ShoppingCart } from '@material-ui/icons';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { CartContext } from '../../store/CartContext';

export default function Header() {
  const storeData = useMemo(() => new StoreData(), []);
  const { cart } = useContext(CartContext);
  const [anchorEl, setAnchorEl] = useState<Element | null>(null);
  const [categories, setCategories] = useState([] as CategoryDetails[]);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    storeData.getCategories().then(data => setCategories(data));
  }, [storeData]);

  const handleMenuClick = (event: React.MouseEvent) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (category: CategoryDetails) => {
    navigate(`/list/${category.name}`);
    setAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleCartClick = (event: React.MouseEvent) => {
    navigate(location.pathname.includes('demo') ? `/demo/checkout-iframe` : '/cart');
  };

  if (
    window?.location.pathname === '/demo' ||
    window?.location.pathname === '/terminal' ||
    (window?.location.pathname.includes('iframe') &&
      !window?.location.pathname.includes('iframe-desktop') &&
      window?.location.search &&
      !window?.location.search.includes('mid')) ||
    (window?.location.pathname.includes('iframe-desktop') && !window?.location.search.includes('orderId'))
  ) {
    return <></>;
  }

  return (
    <AppBar position="sticky" className="Header">
      <Toolbar>
        {!location.pathname.includes('demo') && (
          <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleMenuClick}>
            <MenuIcon />
          </IconButton>
        )}
        {!location.pathname.includes('demo') && (
          <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleMenuClose}>
            {categories.map(cat => (
              <MenuItem key={cat.name} onClick={event => handleMenuItemClick(cat)}>
                {cat.title}
              </MenuItem>
            ))}
          </Menu>
        )}
        <Typography variant="h6" className="heading">
          {location.pathname.includes('demo') ? <span>FlexFactor Demo Simulator</span> : <Link to="/">Shop</Link>}
        </Typography>
        {location.pathname !== '/demo/ladies_outerwear' && !!StoreData.getCartSize(cart) && (
          <IconButton edge="end" color="inherit" aria-label="shopping cart" onClick={handleCartClick}>
            <Badge badgeContent={StoreData.getCartSize(cart)} color="secondary" overlap="rectangular">
              <ShoppingCart />
            </Badge>
          </IconButton>
        )}
      </Toolbar>
    </AppBar>
  );
}
